import {
    FormDataConsumer,
    ReferenceInput,
    SelectInput,
    SimpleForm,
    TextInput,
    useCreate,
    useGetOne,
    useNotify,
} from 'react-admin';
import { Pdfs } from '../../custom';
import Button from '@mui/material/Button';
import { useController } from 'react-hook-form';
import { PictureAsPdf } from '@mui/icons-material';
import { useEffect, useState, useRef } from 'react';
import FileUpload from './FileUpload';
import { PdfAutoCompleteInput } from './autoCompleteInputs/PdfAutoComplete';
import { PdfCategoryAutoCompleteInput } from './autoCompleteInputs/PdfCategoryAutoComplete';

export const PdfModal = (props: any) => {
    const [title, setTitle] = useState(props?.title || '');
    const [selectedUrl, setSelectedUrl] = useState('');
    const notify = useNotify();
    const [create, { isLoading }] = useCreate();
    return (
        <div
            className={
                'fixed top-0 left-0 right-0 bottom-0 z-[100] bg-gray-400 bg-opacity-50 flex flex-col items-center justify-center'
            }
        >
            <div className={'rounded-md bg-white shadow-md w-[90vw] md:w-[40vw] '}>
                <SimpleForm toolbar={<></>} defaultValues={{ title }}>
                    <FormDataConsumer>
                        {({ formData }) => {
                            const pdfCategory = formData.categoryId;
                            return (
                                <div className="w-full">
                                    <TextInput
                                        fullWidth
                                        source={'title'}
                                        value={title}
                                        onChange={e => {
                                            setTitle(e.target.value);
                                        }}
                                        required
                                    />
                                    <FileUpload
                                        type="PDF_NOTES"
                                        required={true}
                                        source="url"
                                        label="select Pdf"
                                        setSelectedUrl={setSelectedUrl}
                                        accept="application/pdf"
                                        multiple={false}
                                    />
                                    <PdfCategoryAutoCompleteInput
                                        fullWidth
                                        required
                                        source={'categoryId'}
                                    />

                                    <div className={'flex space-x-2 mt-2 border-t pt-4'}>
                                        <Button
                                            disabled={
                                                isLoading || !title || !selectedUrl || !pdfCategory
                                            }
                                            onClick={() => {
                                                if (!title || !selectedUrl) {
                                                    notify('Please fill Title and pdf', {
                                                        type: 'error',
                                                        messageArgs: {},
                                                    });
                                                    return;
                                                }
                                                create(
                                                    'pdfs',
                                                    {
                                                        data: {
                                                            title: title,
                                                            url: selectedUrl,
                                                            categoryId: pdfCategory,
                                                        },
                                                    },
                                                    {
                                                        onSuccess: e => {
                                                            if (props.onClose) {
                                                                props.onClose(e.id);
                                                            }
                                                        },
                                                    },
                                                );
                                            }}
                                        >
                                            Attach Pdf
                                        </Button>
                                        <Button
                                            color={'error'}
                                            onClick={() => {
                                                if (props.onClose) {
                                                    props.onClose('');
                                                }
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </div>
                            );
                        }}
                    </FormDataConsumer>
                </SimpleForm>
            </div>
        </div>
    );
};

const PdfAutocompleteInput = (props: any) => {
    const [createPdf, setCreatePdf] = useState(false);
    const i = useController({ name: props.source });
    const pdfId = i.field.value;

    const lastValidPdfId = useRef(pdfId);
    const isClearing = useRef(false);

    useEffect(() => {
        if (pdfId && !isClearing.current) {
            lastValidPdfId.current = pdfId;
        }
    }, [pdfId]);

    const { data: selectedPdf, isLoading } = useGetOne(
        'pdfs',
        { id: lastValidPdfId.current || pdfId },
        {
            enabled: !!(lastValidPdfId.current || pdfId),
            retry: false,
            staleTime: 5 * 60 * 1000,
        },
    );

    useEffect(() => {
        console.log('pdfId changed:', pdfId);
        console.log('lastValidPdfId:', lastValidPdfId.current);
    }, [pdfId]);

    useEffect(() => {
        console.log('selectedPdf changed:', selectedPdf);
        if (selectedPdf?.url) {
            props?.setSelectedPdfUrl(selectedPdf.url);
        }
    }, [selectedPdf]);

    const currentPdfId = pdfId || lastValidPdfId.current;

    if (currentPdfId && selectedPdf) {
        return (
            <div
                className={
                    'w-full p-4 rounded-md bg-gray-50 mb-4 border border-gray-200 flex justify-between items-center'
                }
            >
                <div className="flex items-center gap-4">
                    <PictureAsPdf className={'text-black'} style={{ fontSize: '100px' }} />
                    <div className="text-sm text-gray-600">
                        {selectedPdf?.title || 'PDF Selected'}
                    </div>
                </div>
                <Button
                    color={'error'}
                    onClick={() => {
                        isClearing.current = true;
                        i.field.onChange('');
                        lastValidPdfId.current = null;
                        props?.setSelectedPdfUrl('');
                        setTimeout(() => {
                            isClearing.current = false;
                        }, 100);
                    }}
                >
                    Change Pdf
                </Button>
            </div>
        );
    }

    return (
        <div className={'w-full'}>
            <>
                {createPdf && (
                    <PdfModal
                        title={props?.formData?.title}
                        onClose={(e: any) => {
                            if (e) {
                                isClearing.current = false;
                                i.field.onChange(e);
                            }
                            setCreatePdf(false);
                        }}
                    />
                )}
                <div className={'flex justify-between items-center'}>
                    <div className={'text-xs text-gray-500'}>Search by Pdf Title</div>
                    <div
                        onClick={() => {
                            setCreatePdf(true);
                        }}
                        className={
                            'text-indigo-500 text-sm font-medium py-1 cursor-pointer px-2 hover:bg-indigo-50 transition-all duration-200 rounded'
                        }
                    >
                        Add A New Pdf
                    </div>
                </div>
                <PdfAutoCompleteInput
                    source={props.source || 'pdfId'}
                    label={props.label || 'Pdf'}
                    multiple={props.multiple}
                />
            </>
        </div>
    );
};
export default PdfAutocompleteInput;
